// Use current origin for API calls to avoid CORS issues on custom domains
// When deployed at nazca360.com or nazcaexperience.com, API calls must go to /api
export const BACKEND_URL = typeof window !== 'undefined' ? window.location.origin : '';
export const API = `${BACKEND_URL}/api`;

export function resolveImg(src) {
  if (!src) return '';
  if (src.startsWith('/uploads/')) {
    return `/api${src}`;
  }
  if (src.startsWith('/backend/uploads/')) {
    return `/api${src.replace('/backend/uploads/', '/uploads/')}`;
  }
  if (src.startsWith('/api')) {
    return `${BACKEND_URL}${src}`;
  }
  return src;
}
